import { useState, useEffect, useCallback } from 'react';
import { CheckCircle, XCircle, Info, X } from 'lucide-react';

let toastQueue = [];
let listeners = [];

const notify = (listeners) => listeners.forEach(fn => fn([...toastQueue]));

export const toast = {
    success: (message, duration = 3000) => addToast('success', message, duration),
    error: (message, duration = 4000) => addToast('error', message, duration),
    info: (message, duration = 3000) => addToast('info', message, duration),
};

const addToast = (type, message, duration) => {
    const id = Date.now() + Math.random();
    toastQueue = [...toastQueue, { id, type, message, duration }];
    notify(listeners);
    setTimeout(() => removeToast(id), duration);
    return id;
};

const removeToast = (id) => {
    toastQueue = toastQueue.filter(t => t.id !== id);
    notify(listeners);
};

const ICONS = {
    success: CheckCircle,
    error: XCircle,
    info: Info,
};

const STYLES = {
    success: 'bg-green-50 border-green-200 text-green-800',
    error: 'bg-red-50 border-red-200 text-red-800',
    info: 'bg-blue-50 border-blue-200 text-blue-800',
};

const ICON_STYLES = {
    success: 'text-green-500',
    error: 'text-red-500',
    info: 'text-blue-500',
};

export const ToastContainer = () => {
    const [toasts, setToasts] = useState([]);

    useEffect(() => {
        const handler = (queue) => setToasts(queue);
        listeners.push(handler);
        return () => { listeners = listeners.filter(l => l !== handler); };
    }, []);

    if (toasts.length === 0) return null;

    return (
        <div className="fixed bottom-4 right-4 z-[9999] flex flex-col gap-2 pointer-events-none">
            {toasts.map(({ id, type, message }) => {
                const Icon = ICONS[type];
                return (
                    <div
                        key={id}
                        className={`flex items-center gap-3 px-4 py-3 rounded-xl border shadow-lg max-w-sm pointer-events-auto animate-in slide-in-from-right-4 ${STYLES[type]}`}
                    >
                        <Icon className={`w-5 h-5 flex-shrink-0 ${ICON_STYLES[type]}`} />
                        <span className="text-sm font-medium flex-1">{message}</span>
                        <button
                            onClick={() => removeToast(id)}
                            className="opacity-60 hover:opacity-100 transition-opacity flex-shrink-0"
                        >
                            <X className="w-4 h-4" />
                        </button>
                    </div>
                );
            })}
        </div>
    );
};

export default ToastContainer;
